/** --------------------------------------------------
*
*   paragraphs
*   PARAGRAPH FAQ
*
*  -------------------------------------------------- */

(function (Drupal, once, duo) {
  Drupal.behaviors.paragraph_faq = {

    attach: function (context, settings) {
      const self = this;

      // only do the following once:
      if (!once('paragraph_faq', 'html').length) {
        return;
      }
      self.init(context, settings);
    },

    init: function(context, settings) {
      const self = this;

      // loop through all of the "faq paragraph" blocks
      // to create toggle-zones:
      const faqParagraphs = document.querySelectorAll('.js-p-faq');
      faqParagraphs.forEach(function(element) {
        const faqParagraph = element;

        const titleBlock = faqParagraph.querySelector('.js-p-faq-title');
        const contentBlock = faqParagraph.querySelector('.js-p-faq-content');

        if(titleBlock !== null && contentBlock !== null) {

          // get a unique ID for the toggle:
          const faqId = 'faq-' + duo.Utils.uniqueId;

          // hide the content block and add unique ID:
          contentBlock.setAttribute('hidden', 'true');
          contentBlock.setAttribute('id', faqId);

          // add a toggle button:
          const toggleButtonText = titleBlock.innerHTML;
          const toggleButton = document.createElement('button');
          toggleButton.setAttribute('aria-expanded', 'false');
          toggleButton.setAttribute('aria-controls', faqId);
          toggleButton.classList.add('p-faq__toggle-button');
          toggleButton.classList.add('js-p-faq-togglebutton');
          toggleButton.innerHTML = `
            <span class="p-faq__toggle-button-text">${ toggleButtonText }</span>
            <span class="p-faq__toggle-button-icon">
              <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false">
                <path d="M9.8 4.6 6.3 8.1s-.2.1-.3.1-.3 0-.4-.1L2.1 4.6S2 4.4 2 4.3s.1-.3.2-.4c0 0 .2-.1.3-.1h7c.2 0 .4.2.4.2s.1.1.1.2-.1.3-.2.4z" />
              </svg>
            </span>
          `;
          titleBlock.parentNode.insertBefore(toggleButton, titleBlock.nextSibling);
          titleBlock.classList.add('visually-hidden');

          // toggle button click event:
          toggleButton.addEventListener('click', function() {
            self._toggleItem(toggleButton);
          });

          // add "ready class":
          faqParagraph.classList.add('js-ready');
        }
      });
    },

    _toggleItem(toggleButton) {
      const controlledElementId = toggleButton.getAttribute('aria-controls');
      const controlledElement = document.querySelector(`#${controlledElementId}`);
      const state = toggleButton.getAttribute('aria-expanded') === 'false' ? true : false;

      // set the expanded state on the button:
      toggleButton.setAttribute('aria-expanded', state);

      // set hidden state on the content:
      if(state) {
        controlledElement.removeAttribute('hidden');
      } else {
        controlledElement.setAttribute('hidden', 'true');
      }
    }
  };
})(Drupal, once, window.duo = window.duo || {});
